// Mock data for IWMS Dashboard - Ulhasnagar Municipal Corporation
export const mockProjects = [
  // PWD Projects
  {
    id: 1,
    projectName: "Kalyan-Ulhasnagar Road Widening Phase-II",
    department: "PWD",
    fundHead: "State Development Fund",
    fundCategory: "Infrastructure",
    projectType: "Road Development",
    tsAmount: 45000000,
    tsDate: "2024-03-15",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 65
  },
  {
    id: 2,
    projectName: "Construction of Multi-level Parking at Station Road",
    department: "PWD",
    fundHead: "Municipal Fund",
    fundCategory: "Infrastructure",
    projectType: "Building Construction",
    tsAmount: 28000000,
    tsDate: "2024-01-20",
    financialYear: "2024-25",
    status: "Completed",
    completionPercentage: 100
  },
  {
    id: 3,
    projectName: "Renovation of Municipal Office Complex",
    department: "PWD",
    fundHead: "Central Grant",
    fundCategory: "Administrative",
    projectType: "Renovation",
    tsAmount: 15000000,
    tsDate: "2023-11-10",
    financialYear: "2023-24",
    status: "Delayed",
    completionPercentage: 40
  },
  
  // Water Supply Projects
  {
    id: 4,
    projectName: "24x7 Water Supply Scheme - Zone A",
    department: "Water Supply",
    fundHead: "AMRUT Scheme",
    fundCategory: "Water Supply",
    projectType: "Pipeline Installation",
    tsAmount: 75000000,
    tsDate: "2024-02-05",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 45
  },
  {
    id: 5,
    projectName: "Water Treatment Plant Upgrade",
    department: "Water Supply",
    fundHead: "State Water Board Grant",
    fundCategory: "Water Supply",
    projectType: "Plant Upgrade",
    tsAmount: 120000000,
    tsDate: "2024-04-01",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 25
  },
  {
    id: 6,
    projectName: "Leak Detection and Repair Program",
    department: "Water Supply",
    fundHead: "Municipal Fund",
    fundCategory: "Water Supply",
    projectType: "Maintenance",
    tsAmount: 8000000,
    tsDate: "2023-12-15",
    financialYear: "2023-24",
    status: "Completed",
    completionPercentage: 100
  },

  // Electric Projects
  {
    id: 7,
    projectName: "LED Street Light Installation - Phase III",
    department: "Electric",
    fundHead: "Energy Efficiency Fund",
    fundCategory: "Power",
    projectType: "Street Lighting",
    tsAmount: 18000000,
    tsDate: "2024-01-10",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 80
  },
  {
    id: 8,
    projectName: "Smart Grid Implementation",
    department: "Electric",
    fundHead: "Central Smart City Mission",
    fundCategory: "Power",
    projectType: "Grid Modernization",
    tsAmount: 95000000,
    tsDate: "2024-05-20",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 15
  },
  {
    id: 9,
    projectName: "Electrical Infrastructure for New Market",
    department: "Electric",
    fundHead: "Municipal Fund",
    fundCategory: "Power",
    projectType: "Infrastructure",
    tsAmount: 12000000,
    tsDate: "2023-10-05",
    financialYear: "2023-24",
    status: "Completed",
    completionPercentage: 100
  },

  // Health Projects
  {
    id: 10,
    projectName: "Primary Health Center Modernization",
    department: "Health",
    fundHead: "National Health Mission",
    fundCategory: "Healthcare",
    projectType: "Healthcare Infrastructure",
    tsAmount: 35000000,
    tsDate: "2024-02-28",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 55
  },
  {
    id: 11,
    projectName: "Mobile Health Van Fleet Expansion",
    department: "Health",
    fundHead: "State Health Department",
    fundCategory: "Healthcare",
    projectType: "Mobile Healthcare",
    tsAmount: 22000000,
    tsDate: "2024-01-15",
    financialYear: "2024-25",
    status: "In Progress",
    completionPercentage: 70
  },
  {
    id: 12,
    projectName: "Waste Management System for Hospitals",
    department: "Health",
    fundHead: "Pollution Control Board Grant",
    fundCategory: "Healthcare",
    projectType: "Waste Management",
    tsAmount: 16000000,
    tsDate: "2023-09-20",
    financialYear: "2023-24",
    status: "Completed",
    completionPercentage: 100
  }
];

// Filter options
export const filterOptions = {
  financialYears: ["2025-2026", "2024-2025", "2023-2024"], // Updated to match database format
  fundCategories: ["Infrastructure", "Water Supply", "Power", "Healthcare", "Administrative"],
  fundHeads: [
    "Municipal Fund",
    "State Development Fund", 
    "Central Grant",
    "AMRUT Scheme",
    "State Water Board Grant",
    "Energy Efficiency Fund",
    "Central Smart City Mission",
    "National Health Mission",
    "State Health Department",
    "Pollution Control Board Grant"
  ],
  projectTypes: [
    "Road Development",
    "Building Construction", 
    "Renovation",
    "Pipeline Installation",
    "Plant Upgrade",
    "Maintenance",
    "Street Lighting",
    "Grid Modernization",
    "Infrastructure",
    "Healthcare Infrastructure",
    "Mobile Healthcare",
    "Waste Management"
  ],
  departments: ["PWD", "Water Supply", "Electric", "Health"]
};

// Helper functions
export const formatCurrency = (amount) => {
  // Handle null, undefined, or non-numeric values
  if (!amount || isNaN(amount) || amount === 0) {
    return '₹0';
  }
  
  const numericAmount = Number(amount);
  
  if (numericAmount >= 10000000) {
    return `₹${(numericAmount / 10000000).toFixed(1)} Cr`;
  } else if (numericAmount >= 100000) {
    return `₹${(numericAmount / 100000).toFixed(1)} L`;
  } else if (numericAmount >= 1000) {
    return `₹${(numericAmount / 1000).toFixed(0)} K`;
  } else {
    return `₹${numericAmount.toLocaleString('en-IN')}`;
  }
};

export const getDepartmentColor = (department) => {
  const colors = {
    "PWD": "from-blue-500 to-blue-600",
    "Water Supply": "from-cyan-500 to-teal-600", 
    "Electrical": "from-orange-500 to-amber-600",
    "Health": "from-rose-500 to-pink-600",
    "IT": "from-purple-500 to-indigo-600",
    "Garden": "from-emerald-500 to-green-600"
  };
  return colors[department] || "from-gray-500 to-gray-600";
};

export const getDepartmentIcon = (department) => {
  const icons = {
    "PWD": "🏗️",
    "Water Supply": "💧",
    "Electrical": "⚡",
    "Health": "🏥",
    "Garden": "🌳",
    "IT": "💻"
  };
  return icons[department] || "📋";
};